import useApiRequest from "@/lib/hooks/use-request";
import { OrganizationListResponseDto } from "@/lib/interfaces/organisations";
import { Paginated, Pagination } from "@/lib/interfaces/utils";
import DataFetchParent from "@/ui-components/ui/data-fetch";
import { Dispatch, SetStateAction, useCallback, useEffect, useState } from "react";
import OrganisationsDataTable from "./organisations-data-table";

export const OrganisationFetcher = ({
  searchQuery,
  setReload,
  reload,
}: {
  searchQuery: string;
  setReload: Dispatch<SetStateAction<boolean>>;
  reload: boolean;
}) => {
  const [items, setItems] = useState<OrganizationListResponseDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { apiRequest } = useApiRequest();
  const [pagination, setPagination] = useState<Pagination>({
    pageIndex: searchQuery.split("page=")[1] ? parseInt(searchQuery.split("page=")[1].split("&")[0]) - 1 : 0,
    pageSize: 10,
  });

  const [pageCount, setPageCount] = useState<number>(0);

  const getItemsPaginated = useCallback(async () => {
    setIsLoading(true);
    let url = `contacts/organizations?limit=${pagination.pageSize}&page=${pagination.pageIndex + 1}`;
    const response = await apiRequest<Paginated<OrganizationListResponseDto>>(url, "GET");
    setIsLoading(false);
    if (response.data) {
      setItems(response.data.docs);
      setPageCount(response.data.pageCount);
    }
  }, [apiRequest, pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    getItemsPaginated();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination, getItemsPaginated, searchQuery, reload]);

  return (
    <DataFetchParent
      data={items}
      isLoading={isLoading}
      renderElement={(response: OrganizationListResponseDto[]) => (
        <div className="w-full p-4">
          <OrganisationsDataTable
            data={response}
            isLoading={isLoading}
            pageCount={pageCount}
            pagination={pagination}
            setPagination={setPagination}
            setReload={setReload}
          />
        </div>
      )}
    />
  );
};

export default OrganisationFetcher;
